import React from 'react';
import { useTranslation } from 'react-i18next';
import useCoordinateMeeting from '../hookss/useCoordinateMeeting';
const ControllerCTH = () => {
    const { t } = useTranslation();
    const { handleClick } = useCoordinateMeeting();
    return (React.createElement("div", null,
        React.createElement("div", { className: 'controller-participant-header controler-header' }, t('menuController.titleHeaderCTH')),
        React.createElement("div", { className: "controler-list-item" },
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('turnOffAllMicroSIP') }, t('menuController.turnOffMicroCTH')),
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('turnOffAllMediaSIP') }, t('menuController.turnOffCameraCTH')),
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('turnOnAllMicroSIP') }, t('menuController.turnOnMicroCTH')),
            React.createElement("div", { className: "controler-item item-tab shape-button", onClick: () => handleClick('turnOnAllMediaSIP') }, t('menuController.turnOnCameraCTH')))));
};
export default ControllerCTH;
